// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"705":"1343fd08","793":"770e1d0b"}[chunkId] + ".chunk.js";
};